import { useQuery } from "@tanstack/react-query";
import { getServicesCategories } from "api/main";
import { TextSkeleton } from "components/TextSkeleton";
import useSetting from "hooks/useSetting";
import dynamic from "next/dynamic";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useState } from "react";
import { getHeaderItems, getSideBarItems } from "utils/getHeaderItems";
const PWAModal = dynamic(() => import("components/General/Dialogs/PWAModal"), {
  ssr: false,
});

function MobileDrawer({
  onClose,
  isCRDC,
  open,
  t,
}: {
  onClose: (e: React.MouseEvent<HTMLElement>) => void;
  isCRDC: boolean;
  open: boolean;
  t: any;
}) {
  const [openPWA, setOpenPWA] = useState(false);
  const [openItem, setOpenItem] = useState<number>(-1);
  const [openItem2, setOpenItem2] = useState<number>(-1);
  const { data: settingData } = useSetting();
  const { locale } = useRouter();

  const { data: servicesCategories } = useQuery(["getServicesCategories", locale], () =>
    getServicesCategories(locale)
  );

  return (
    <>
      <div
        className={`rounded-tb-[12px] fixed top-0 z-[40] h-screen pppp ${
          open ? "right-0 px-16 py-24" : "right-[-76%] "
        } w-[72%] rounded-tl-[12px] bg-white  shadow-[0_4px_20px_rgba(0,0,0,0.16)] backdrop-blur-[100px] duration-500 ease-in-out`}
      >
        <div className="h-full overflow-x-hidden overflow-y-scroll no-scrollbar">
          <div className="mb-40 flex items-center justify-center">
            <Link passHref href="/">
              <Image
                src={isCRDC ? "/assets/logo-tahgig.png" : "/assets/logo.png"}
                width="120"
                height={"30"}
                alt="لوگو بیمارستان ولیعصر"
              />
            </Link>
          </div>
          <div className={` flex flex-col`}>
            {getHeaderItems(isCRDC, t, servicesCategories?.data, locale)?.map((el: any, i) => {
              return el.path ? (
                <Link
                  prefetch={false}
                  key={i}
                  href={el.path}
                  passHref
                  onClick={onClose}
                  className="mb-10 me-50 text-14 text-gray-7C7C7C"
                >
                  {el.title}
                </Link>
              ) : (
                el.children && (
                  <div className="mb-10 flex flex-col" key={i}>
                    <p
                      className="flex items-center justify-between text-14 text-gray-7C7C7C"
                      onClick={() => setOpenItem((pre) => (pre !== -1 ? -1 : i))}
                    >
                      {el.title}

                      <i
                        className={`icon-direction- rotate-90 text-18 text-gray-7C7C7C  ${
                          openItem === i ? "-rotate-90" : ""
                        }`}
                      />
                    </p>
                    {openItem === i && (
                      <div className="ms-16 mt-12 flex flex-col">
                        {el?.children.length === 0 && (
                          <div className="flex flex-col gap-10">
                            {[...Array(3)].map((item, index) => (
                              <TextSkeleton key={index} />
                            ))}
                          </div>
                        )}

                        {el.children.map((el2: any, i2: number) => {
                          return (
                            <Link
                              prefetch={false}
                              key={i2}
                              href={el2.path}
                              passHref
                              onClick={onClose}
                              className="mb-10 me-50 text-14 text-gray-7C7C7C"
                            >
                              {el2.title}
                            </Link>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )
              );
            })}

            {getSideBarItems(isCRDC, t)?.map((el: any, i) => {
              return el.path ? (
                <Link
                  prefetch={false}
                  key={i}
                  href={el.path}
                  passHref
                  onClick={onClose}
                  className="mb-10 me-50 text-14 text-gray-7C7C7C"
                >
                  {el.title}
                </Link>
              ) : (
                el.children && (
                  <div key={i} className="mb-10 flex flex-col">
                    <p
                      className="flex items-center justify-between text-14 text-gray-7C7C7C"
                      onClick={() => setOpenItem2((pre) => (pre !== -1 ? -1 : i))}
                    >
                      {el.title}

                      <i
                        className={`icon-direction- rotate-90 text-18 text-gray-7C7C7C  ${
                          openItem2 === i ? "-rotate-90" : ""
                        }`}
                      />
                    </p>
                    {openItem2 === i && (
                      <div className="ms-16 mt-12 flex flex-col">
                        {el.children?.[0] === "covid"
                          ? settingData?.covid19Years?.map((item: any, i2: number) => {
                              return (
                                <Link
                                  prefetch={false}
                                  href={"/research/covid"}
                                  passHref
                                  key={i2}
                                  className="mb-10 me-50 text-14 text-gray-7C7C7C"
                                >
                                  {t("Year")} {item}
                                </Link>
                              );
                            })
                          : el.children?.map((el2: any, i2: number) => {
                              return (
                                el2.path && (
                                  <Link
                                    prefetch={false}
                                    key={i2}
                                    href={el2.path}
                                    passHref
                                    onClick={onClose}
                                    className="mb-10 me-50 text-14 text-gray-7C7C7C"
                                  >
                                    {el2.title}
                                  </Link>
                                )
                              );
                            })}
                      </div>
                    )}
                  </div>
                )
              );
            })}

            <div onClick={() => setOpenPWA(true)} className="flex cursor-pointer items-center ">
              <i className={`icon-requests text-14 text-primary-main`} />
              <p className="text-14 text-gray-7C7C7C">راهنمای نصب اپلیکیشن PWA</p>
            </div>
          </div>
        </div>
      </div>
      {openPWA && <PWAModal open={openPWA} setOpen={setOpenPWA} />}
    </>
  );
}

export default MobileDrawer;
